import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

export default function Loading() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        padding: "20px",
        "& span.MuiCircularProgress-root.MuiCircularProgress-indeterminate": {
          width: "50px !important",
          height: "50px !important",
        },
      }}
    >
      <CircularProgress
        sx={{
          "& .MuiCircularProgress-circle.MuiCircularProgress-circleIndeterminate":
            { stroke: "#3E94C2 !important" },
        }}
      />
    </Box>
  );
}
